import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/sets/')({
    component: RouteComponent,
});

function RouteComponent() {
    return <Navigate to="/sets/created-box" replace />;
}
